import { render } from "./AddNewCompetitor.vue?vue&type=template&id=3f01ec88&scoped=true"
import script from "./AddNewCompetitor.vue?vue&type=script&lang=js"
export * from "./AddNewCompetitor.vue?vue&type=script&lang=js"

import "./AddNewCompetitor.vue?vue&type=style&index=0&id=3f01ec88&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f01ec88"]])

export default __exports__